<template>
  <div class="task-center" :class="{ show: showCenter }">
    <a-tabs
      :tabBarGutter="0"
      :activeKey="tabIndex"
      :tabBarStyle="barStyle"
      :type="'card'"
      class="myTab"
      @change="changeTab"
    >
      <a-tab-pane :key="0">
        <template slot="tab">
          <div class="normal-tab1" :class="tabIndex == 0 ? 'active-tab1' : ''"></div>
        </template>
        <div class="tab-content">
          <div class="t-t-tile">业务说明</div>
          <div class="t-describe" v-if="allFinish && isSubmit == 1">
            <p style="color: #f8a036; font-size: 18px; font-weight: bold; padding-top: 10px; text-align: center">
              该应用题已做答。
            </p>
          </div>
          <div class="t-describe" v-else>{{ curTaskData.content }}</div>
          <div class="task-btn-group" v-if="!allFinish && isSubmit != 1">
            <a-button size="small" ghost type="link" v-if="curTaskData.videoId" @click="playVideo(curTaskData)">
              <a-icon type="video-camera" />播放视频
            </a-button>
            <a-button
              type="primary"
              style="float: right"
              @click="payfpVisible = true"
              v-if="curTaskData.modType === '3'"
              >开始购买</a-button
            >
            <a-button
              type="primary"
              style="float: right; margin-right: 5px"
              @click="isFinishFlag && finishCurTask(curTaskData)"
              v-if="curTaskData.isFinish !== '2'"
              >结束业务</a-button
            >
          </div>
          <div class="t-t-tile" v-if="(isO2O === '1' && !curTaskData.bgList) || curTaskData.bgList">背景单据</div>
          <div>
            <div class="t-background-list" v-if="curTaskData.bgList">
              <a-button
                size="small"
                icon="paper-clip"
                ghost
                type="link"
                :key="curBg.id"
                v-for="curBg in curTaskData.bgList"
                @click="bgBtnClick(curBg)"
              >
                <!-- <a :href="cdnImg(curBg.bgUrl)" v-if="curBg.bgUrl.split('.')[1] !== 'png'">{{ curBg.label }}</a> -->
                <span> {{ curBg.label }}</span>
              </a-button>
            </div>
            <div v-if="isO2O === '1' && !curTaskData.bgList">
              <span class="t-describe">温馨提示：该课程需结合线下教材进行操作</span>
            </div>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane :key="1">
        <template slot="tab">
          <div class="normal-tab2" :class="tabIndex == 1 ? 'active-tab2' : ''"></div>
        </template>
        <div class="tab-content" v-if="taskData && taskData.length > 0">
          <div v-for="(obj, i) in taskData" :key="obj.id" class="task-item" @click="selectTask(i)">
            <div class="task-item-title">{{ i + 1 }}、{{ obj.modName }}</div>
            <div class="task-item-button task-green" v-if="obj.isFinish == '0'">未开始</div>
            <div class="task-item-button task-red" v-if="obj.isFinish == '1'">进行中</div>
            <div class="task-item-button task-gary" v-if="obj.isFinish == '2'">已结束</div>
          </div>
          <div style="text-align: center; border-top: 1px solid grey; padding: 10px">
            <a-button
              v-if="allFinish && isSubmit != 1"
              type="primary"
              style="background: #f78d1d; border: solid 1px #da7c0c; color: #fef4e9"
              @click="finishTask()"
              id="open"
              >确认完成</a-button
            >
            <p
              v-if="allFinish && isSubmit == 1 && testType != '1'"
              id="down"
              style="color: #f8a036; font-size: 18px; font-weight: bold; padding-top: 10px"
            >
              您已交卷，请至个人信息界面查看详情情况。
            </p>
            <p
              v-if="allFinish && isSubmit == 1 && testType == '1'"
              id="down1"
              style="color: #f8a036; font-size: 18px; font-weight: bold; padding-top: 10px; text-align: center"
            >
              您已交卷。
            </p>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
    <a-modal
      title="购买发票"
      :visible="payfpVisible"
      :confirm-loading="payLoading"
      @ok="handlePay"
      @cancel="payfpVisible = false"
      :maskClosable="false"
    >
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-item label="发票种类" required>
            <a-select v-model="taxClass">
              <a-select-option value="0"> 增值税专用发票 </a-select-option>
              <a-select-option value="1"> 增值税普通发票 </a-select-option>
              <a-select-option value="3"> 增值税电子普通发票 </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-item label="购买数量" required>
            <a-input v-model="taxBillBuyNum" type="number"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util.js'
export default {
  name: 'TaskBoard',
  data() {
    return {
      testType: '1', // 1代表考试，其它代表练习
      // isSubmit: 0, // 第一次进业务是否为已经全部提交过的
      // curTaskData: {},
      tabIndex: 1,
      showCenter: false,
      barStyle: {
        margin: '10px 0px 5px',
        border: 'none',
      },
      taxClass: '0',
      taxBillBuyNum: '',
      payfpVisible: false,
      payLoading: false,
      isFinishFlag: true,
    }
  },
  computed: {
    ...mapState('practice', ['taskData', 'curTaskData', 'loginInfo', 'businessData', 'isSubmit']),
    allFinish() {
      return this.taskData.every((v) => v.isFinish === '2')
    },
    isO2O() {
      return this.businessData.isO2O
    },
  },
  created() {
    console.log('taskData :>> ', this.taskData)
    // console.log(this.taskData)
  },
  methods: {
    changeTab(val) {
      this.tabIndex = val
    },
    selectTask(n) {
      const curTaskData = this.taskData[n]
      console.log(curTaskData)
      this.tabIndex = 0
      this.SET_CUR_TASK_DATA(curTaskData)
    },
    bgBtnClick(bg) {
      this.$emit('openBg', bg)
    },
    playVideo(v) {
      this.$emit('openBg', v)
    },
    async handlePay() {
      this.payLoading = true
      const curTask = this.curTaskData
      curTask.isFinish = '1'
      const newCurTask = this.taskData.find((v) => v.id === curTask.id)
      this.SET_CUR_TASK_DATA(newCurTask)
      if (this.taxClass != null && this.taxBillBuyNum != null) {
        const params = parseParam({
          taxClass: this.taxClass,
          taxBillBuyNum: this.taxBillBuyNum,
          moduleId: this.curTaskData.id,
        })
        const res = await this.$http.post(`${Urls.payInvoice}&${params}`)
        console.log(res)
        if (res) {
          this.$success({
            title: '提示',
            content: '购买成功',
            onOk: (resolve) => {
              resolve()
              this.payLoading = false
            },
          })
        } else {
          this.payLoading = false
        }
        this.payfpVisible = false
      }
    },
    async finishCurTask(curTask) {
      this.isFinishFlag = false
      this.$confirm({
        title: '信息',
        content: '确认结束该业务么？',
        cancelText: '取消',
        okText: '确认',
        onOk: async () => {
          const params = parseParam({
            isFinish: curTask.isFinish,
            moduleId: curTask.id,
            status: curTask.status,
          })
          const result = await this.$http.post(`${Urls.updateDetail}&${params}`)
          await this.uploadTestByOSS({ result, isFinish: '2' })
          await this.getBusinessList()
          const newCurTask = this.taskData.find((v) => v.id === curTask.id)
          this.SET_CUR_TASK_DATA(newCurTask)
          this.isFinishFlag = true
        },
        onCancel: () => {
          this.isFinishFlag = true
        },
      })
    },
    finishTask() {
      this.$confirm({
        title: '信息',
        content: '您是否确认结束全部答题',
        cancelText: '取消',
        okText: '确认',
        onOk: async () => {
          const params = parseParam()
          // const res = await this.$http.post(`${Urls.finishTest}&${params}`)
          await this.$http.post(`${Urls.finishTest}&${params}`)
          // if (res) {
          //   if (res.testType === 1) {
          //     // 考试
          //     this.$success({
          //       title: '提示',
          //       content: '本次考试已结束',
          //     })
          //   } else {
          //     this.$success({
          //       title: '提示',
          //       content: '您本次分数为:' + res.score,
          //     })
          //   }
          // }
          await this.getBusinessList()
        },
      })
    },
    ...mapMutations('practice', ['SET_CUR_TASK_DATA']),
    ...mapActions('practice', ['getBusinessList', 'uploadTestByOSS']),
  },
}
</script>
<style lang="less" scoped>
.task-center {
  z-index: 9999;
  position: fixed;
  right: 50px;
  bottom: 20px;
  width: 350px;
  height: 340px;
  background: none repeat scroll 0 0 #1a6ba0;
  border: 5px solid #247caf;
  border-top-left-radius: 15px;
  -webkit-border-top-left-radius: 15px;
  -moz-border-radius-topleft: 15px;
  display: none;
}
.tab-content {
  display: block;
  height: 270px;
  width: 100%;
  background: #253849;
  padding: 2px;
  overflow-y: auto;
  position: relative;
}
.tab-content .t-t-tile {
  font-size: 18px;
  color: #f8a036;
  font-weight: bold;
  padding-top: 5px;
  text-align: center;
}
.tab-content .t-describe {
  padding: 8px;
  color: #ffffff;
  font-size: 14px;
  line-height: 16px;
}
.tab-content .t-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 35px;
}
.tab-content .t-footer button {
  border-radius: 0;
  float: right;
  margin-right: 5px;
}
.normal-tab1 {
  width: 150px;
  height: 45px;
  background-image: url(~@/assets/business-title.png);
  background-repeat: no-repeat;
  background-position: left top;
}
.active-tab1 {
  width: 150px;
  height: 45px;
  background-position: right top;
}
.normal-tab2 {
  width: 150px;
  height: 45px;
  background-image: url(~@/assets/business-title.png);
  background-repeat: no-repeat;
  background-position: left bottom;
}
.active-tab2 {
  width: 150px;
  height: 45px;
  background-position: right bottom;
}
.task-item {
  width: 100%;
  padding: 5px 10px;
  /*height: 30px;*/
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
}
.task-item .task-item-title {
  color: #fff;
  width: 240px;
}
.task-item .task-item-button {
  color: #fff;
  width: 46px;
  font-size: 12px;
  text-align: center;
  border-radius: 5px;
  line-height: 20px;
  height: 20px;
}
.task-green {
  background: #02a855;
}
.task-yellow {
  background: yellow;
}
.task-gary {
  background: #989a99;
}
.task-red {
  background: #fb0101;
}
.task-item :hover {
  cursor: pointer;
  font-weight: bolder;
}
.task-btn-group {
  display: block;
  height: 32px;
  width: 100%;
}
.task-btn-k {
  margin-right: 10px;
  float: right;
  display: block;
}
.t-button {
  border: none;
}
</style>
<style lang="less">
.myTab {
  .ant-tabs-tab {
    border: none !important;
    padding: 0 10px !important;
    height: 45px !important;
    background: 0 0 !important;
    margin-right: 0 !important;
  }

  .ant-tabs-nav-container-scrolling {
    overflow: hidden !important;
    white-space: nowrap !important;
    padding: 0 !important;
  }
}
</style>
